<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { TextInputWithButtonDefinition } from 'header/types';

    interface Props {
        field: TextInputWithButtonDefinition;
    }

    let { field }: Props = $props();

    const dispatch = createEventDispatcher();

    const onChange = (e: { currentTarget: HTMLInputElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: e.currentTarget.value,
            },
        });
    };
</script>

<div class="field">
    <input
        class="input"
        type="text"
        disabled={field.changeable === false}
        value={field.value}
        oninput={onChange}
    />
    <a class="button" title={field.button.tooltip} href={field.button.url} target="_blank"
        ><span>ℹ</span></a
    >
</div>

<style lang="scss" scoped>
    .field {
        display: flex;
        align-items: center;
        column-gap: 0.5rem;
        font-size: 0.8rem;
    }
    .input {
        flex: 1 0 auto;
    }
    .button {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex: 0 0 1.2rem;
        text-decoration: none;
        font-size: 1.2rem;
        line-height: 1rem;
        color: inherit;
        border: 1px solid #666;
        border-radius: 2px;

        > span {
            padding-bottom: 0.1em;
        }
    }
</style>
